import { useState } from "react";
import { ArrowUp, ArrowDown, Trash2, ChevronDown, ChevronUp, Plus } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { FormFields, move } from "./fields";
import { SECTION_TYPES } from "./schemas";

export default function HomeSections({ draft, setDraft }) {
  const sections = draft.home.sections;
  const [open, setOpen] = useState(null);
  const [newType, setNewType] = useState("custom");
  const set = (next) => setDraft({ ...draft, home: { ...draft.home, sections: next } });
  const add = () => {
    set([...sections, { id: `s${Date.now()}`, type: newType, enabled: true, headline: "New section" }]);
    setOpen(sections.length);
  };
  return (
    <div className="space-y-3" data-testid="admin-home-sections">
      <p className="mb-4 text-sm text-bt-text">Reorder, hide or edit each homepage section. Changes go live when you save.</p>
      {sections.map((s, i) => {
        const meta = SECTION_TYPES[s.type] || { label: s.type, fields: [] };
        return (
          <div key={s.id} className="rounded-2xl border border-bt-border bg-white" data-testid={`home-section-${s.id}`}>
            <div className="flex items-center gap-2 px-4 py-3">
              <button onClick={() => setOpen(open === i ? null : i)} className="flex flex-1 items-center gap-2 text-left" data-testid={`home-section-${s.id}-toggle`}>
                {open === i ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                <span className="font-semibold text-bt-heading">{meta.label}</span>
                {s.headline && <span className="hidden text-sm text-bt-sagedeep sm:inline">· {s.headline}</span>}
              </button>
              <Switch checked={s.enabled} onCheckedChange={(v) => set(sections.map((x, j) => (j === i ? { ...x, enabled: v } : x)))} data-testid={`home-section-${s.id}-enabled`} />
              <button className="rounded-lg p-2 hover:bg-bt-sage" onClick={() => set(move(sections, i, -1))} aria-label="Up" data-testid={`home-section-${s.id}-up`}><ArrowUp size={15} /></button>
              <button className="rounded-lg p-2 hover:bg-bt-sage" onClick={() => set(move(sections, i, 1))} aria-label="Down" data-testid={`home-section-${s.id}-down`}><ArrowDown size={15} /></button>
              <button className="rounded-lg p-2 text-red-700 hover:bg-red-50" onClick={() => window.confirm("Remove this section?") && set(sections.filter((_, j) => j !== i))} aria-label="Remove" data-testid={`home-section-${s.id}-remove`}><Trash2 size={15} /></button>
            </div>
            {open === i && (
              <div className="border-t border-bt-border p-5">
                {meta.note && <p className="mb-4 rounded-xl bg-bt-sage px-4 py-2 text-sm">{meta.note}</p>}
                {meta.fields.length > 0 && <FormFields schema={meta.fields} value={s} onChange={(nv) => set(sections.map((x, j) => (j === i ? nv : x)))} prefix={`home-${s.id}`} />}
              </div>
            )}
          </div>
        );
      })}
      <div className="flex flex-wrap items-center gap-2 pt-3">
        <select className="rounded-xl border border-bt-border bg-white px-4 py-3 text-sm" value={newType} onChange={(e) => setNewType(e.target.value)} data-testid="home-section-new-type">
          {Object.entries(SECTION_TYPES).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
        <button onClick={add} className="btn-ghost" data-testid="home-section-add"><Plus size={16} /> Add section</button>
      </div>
    </div>
  );
}
